import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/store/store';
import VueResource from 'vue-resource'

import '@/assets/fonts/galindo/galindo.css';
import '@/assets/fonts/roboto/roboto.css';
import '@/assets/fonts/roboto_condensed/roboto_condensed.css';
import '@/assets/styles/main_styles.css';

Vue.config.productionTip = false;

Vue.use(VueResource);

// Register global components
import UniBanner from '@/components/common/UniBanner.vue';
import UniIcon from '@/components/common/UniIcon.vue';
import UniMenu from '@/components/common/UniMenu.vue';
import UniMess from '@/components/common/UniMess.vue';
import UniPager from '@/components/common/UniPager.vue';
import WaitSpinner from '@/components/common/WaitSpinner.vue';
import UniPost from '@/components/common/UniPost.vue';
import UniInput from '@/components/common/UniInput.vue';
import UniDate from '@/components/common/UniDate.vue';
import TosMess from '@/components/common/TosMess.vue';

import ArtDetail from '@/components/ArtDetail.vue';
import AdmDataSource from '@/components/AdmDataSource.vue';
import AdmEdit from '@/components/AdmEdit.vue';
import CatPick from '@/components/CatPick.vue';
import CatPickBtn from '@/components/common/CatPickBtn';
import Search from '@/views/Search.vue';
import HelpMainImg from '@/components/HelpMainImg.vue';
import PubTos from '@/views/pub/PubTos.vue';
import AdmStats from '@/views/adm/AdmStats.vue';

import UUtilsPlugin from "@/utils/UUtils.js"; // Universal Utilities Plugin
Vue.use(UUtilsPlugin);

Vue.component('UniBanner', UniBanner);
Vue.component('UniIcon', UniIcon);
Vue.component('UniMenu', UniMenu);
Vue.component('UniMess', UniMess);
Vue.component('UniPager', UniPager);
Vue.component('WaitSpinner', WaitSpinner);
Vue.component('ArtDetail', ArtDetail);
Vue.component('AdmDataSource', AdmDataSource);
Vue.component('AdmEdit', AdmEdit);
Vue.component('CatPick', CatPick);
Vue.component('CatPickBtn', CatPickBtn);
Vue.component('Search', Search);
Vue.component('HelpMainImg', HelpMainImg);
Vue.component('PubTos', PubTos);
Vue.component('UniPost', UniPost);
Vue.component('UniInput', UniInput);
Vue.component('UniDate', UniDate);
Vue.component('AdmStats', AdmStats);
Vue.component('TosMess', TosMess);

export const eventBus = new Vue();

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');

